import { Components, Theme } from '@mui/material/styles';

/**
 * Dialog Component Theming
 *
 * All dialogs use the light-blue portal surface (`background.secondary`) by default.
 * Side Drawer mobile dialogs opt out via `SIDE_DRAWER_DIALOG_CLASS`.
 */

/** Opt-out class for Side Drawer dialogs that keep the default paper background. */
export const SIDE_DRAWER_DIALOG_CLASS = 'dialog-surface-side-drawer';

export const createDialogTheme = (theme: Theme): Components['MuiDialog'] => ({
  styleOverrides: {
    paper: {
      backgroundColor: theme.palette.background.secondary,
      '& .MuiOutlinedInput-root:not(.Mui-readOnly)': {
        backgroundColor: theme.palette.background.paper,
      },
    },
    root: {
      [`&.${SIDE_DRAWER_DIALOG_CLASS} .MuiDialog-paper`]: {
        backgroundColor: theme.palette.background.paper,
      },
    },
  },
});

export default createDialogTheme;
